import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer
      className="
        relative overflow-hidden
        bg-bgbackground text-gray-800
        dark:bg-neutral-950 dark:text-gray-200
        border-t border-black/10 dark:border-white/10
      "
    >
      {/* décor / wash : beaucoup plus sombre en dark */}
      <div className="pointer-events-none absolute inset-0">
        {/* halos très discrets */}
        <div className="absolute -top-24 -left-24 h-64 w-64 rounded-full bg-primary/10 blur-3xl dark:bg-primary/8" />
        <div className="absolute -bottom-24 -right-24 h-64 w-64 rounded-full bg-primary/10 blur-3xl dark:bg-primary/8" />

        {/* overlay : assombrit fortement en dark */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/35 to-transparent dark:from-black/70 dark:to-black/40" />

        {/* couche supplémentaire pour garantir contraste */}
        <div className="absolute inset-0 dark:bg-black/60" />
      </div>

      <div className="relative container mx-auto font-satoshi px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
          <div>
            <h4 className="font-semibold mb-2 text-gray-900 dark:text-white">
              {t("footer.legalTitle")}
            </h4>

            <div className="space-y-1 text-gray-700 dark:text-gray-300">
              <p>EI Gaëlle Barbieri</p>

              <address className="not-italic leading-relaxed">
                Espace de Santé Lauduc 
                <br />
                1 Av du périgord 33370 Pompignac
              </address>

              <p className="pt-1">
                {t("footer.phone")}:{" "}
                <a href="tel:0660820289" className="footer-link">
                  06 60 82 02 89
                </a>
              </p>

              <p>SIREN: 918274630</p>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-2 text-gray-900 dark:text-white">
              {t("footer.hostingTitle")}
            </h4>

            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t("footer.hostingContent")}
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-2 text-gray-900 dark:text-white">
              {t("footer.designTitle")}
            </h4>

            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              © {currentYear} Site réalisé par{" "}
              <span className="font-semibold text-gray-900 dark:text-white">
                Laurent VICTORIN
              </span>{" "}
              ·{" "}
              <a
                href="https://www.monappliclub.com"
                className="footer-link text-primary"
                target="_blank"
                rel="noreferrer"
              >
                www.monappliclub.com
              </a>
            </p>

            <div className="mt-3">
              <a href="/cgv" className="footer-link text-primary">
                {t("footer.cgv")}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-black/10 dark:border-white/10 text-center text-xs text-gray-600 dark:text-gray-400">
          <p>
            &copy; {currentYear} {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
